import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

const AlignmentWrapper = styled.div`
  display: flex;
  ${({ styles }) => styles};
`;

const Td = styled.td`
  height: 40px;
  border: none !important;
  padding: 10px 0;
  ${props =>
    props.hasDivider &&
    css`
      position: relative;
      top: 1px;
      &:after {
        content: '';
        position: absolute;
        top: -1px;
        left: 0px;
        height: 1px;
        width: 100%;
        background-color: ${themeGet('colors.black.10')};
      }
      &:first-child:after {
        width: calc(100% - 24px);
        right: 0px;
        left: auto;
      }
      &:last-child:after {
        width: calc(100% - 24px);
      }
    `};
  span {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const ParsedCell = ({ cell, hasDivider, onClick }) => {
  return (
    <Td hasDivider={hasDivider} onClick={onClick}>
      <AlignmentWrapper styles={cell.style} className={cell.className}>
        {cell.content}
      </AlignmentWrapper>
    </Td>
  );
};

export default ParsedCell;
